const LOCAL_STORAGE_KEY = "LEVAI"

interface LocalStorage {
    auth_token: string | null;
}

class _LocalStorageManager {

    public getLocalStorage(): LocalStorage {
        let json = localStorage.getItem(LOCAL_STORAGE_KEY)
        if (json === null) {
            json = "{}"
        }
        return JSON.parse(json) as LocalStorage
    }

    public setLocalStorage(localStorageState: LocalStorage) {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(localStorageState))
    }

    public nuke() {
        this.setLocalStorage({} as LocalStorage);
        
        // Clear all cookies
        document.cookie.split(";").forEach((c) => {
            const eqPos = c.indexOf("=");
            const name = eqPos > -1 ? c.substr(0, eqPos) : c;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
        });
        
        // Clear any other localStorage items that might exist
        // This ensures complete cleanup in case other parts of the app set localStorage directly
        const keysToRemove: string[] = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && key !== LOCAL_STORAGE_KEY) {
                keysToRemove.push(key);
            }
        }
        keysToRemove.forEach(key => localStorage.removeItem(key));
    }

    public loggedIn(): boolean {
        const token = this.getAuthToken();
        return token !== null && token !== "" && token !== undefined;
    }

    public getAuthToken(): string | null {
        return this.getLocalStorage().auth_token;
    }

    public setAuthToken(token: string) {
        const localStorage = this.getLocalStorage();
        localStorage.auth_token = token;
        this.setLocalStorage(localStorage);
    }
}
const LocalStorageManager = new _LocalStorageManager()
export type {LocalStorage};
export {LocalStorageManager};
